export const Occupancy = [
    { name: 'SGL', code: true },
    { name: 'DBL', code: false },
]